// References, and a small built-in sample of the World English Bible (public domain) that the
// prototype data is seeded from synchronously. The whole WEB is served from public/bible/web and
// loaded a book at a time by bible.ts; screens get passages through the source (usePassage).
import { parsePassage, type ParsedRef } from "./books";
import type { Passage } from "./types";

export type { ParsedRef };

/** "Romans 8:28", "rom 8.28", "Phil 4:6-7" → { key: "Phil.4.6-7", label: "Philippians 4:6–7" }. Up to five verses (00 §3). */
export function parseReference(input: string): ParsedRef | null {
  const p = parsePassage(input, 5);
  if (!p || p.from === null) return null;
  return { key: p.key, label: p.label };
}

const WEB: Record<string, string> = {
  "Rom.8.28":
    "We know that all things work together for good for those who love God, for those who are called according to his purpose.",
  "John.3.16":
    "For God so loved the world, that he gave his only born Son, that whoever believes in him should not perish, but have eternal life.",
  "Ps.46.1": "God is our refuge and strength, a very present help in trouble.",
  "Ps.23.1": "Yahweh is my shepherd; I shall lack nothing.",
  "Lam.3.22-23":
    "It is because of Yahweh’s loving kindnesses that we are not consumed, because his mercies don’t fail. They are new every morning. Great is your faithfulness.",
  "Isa.40.31":
    "But those who wait for Yahweh will renew their strength. They will mount up with wings like eagles. They will run, and not be weary. They will walk, and not faint.",
  "Matt.11.28": "Come to me, all you who labor and are heavily burdened, and I will give you rest.",
  "Phil.4.6-7":
    "In nothing be anxious, but in everything, by prayer and petition with thanksgiving, let your requests be made known to God. And the peace of God, which surpasses all understanding, will guard your hearts and your thoughts in Christ Jesus.",
  "Heb.10.24-25":
    "Let’s consider how to provoke one another to love and good works, not forsaking our own assembling together, as the custom of some is, but exhorting one another, and so much more as you see the Day approaching.",
};

export const SAMPLE_REFERENCES = ["Romans 8:28", "Psalm 46:1", "Lamentations 3:22–23", "Philippians 4:6–7"];

/** The built-in sample only (synchronous). For any passage, use bible.ts's `lookupWeb`. */
export function lookupPassage(input: string): Passage | null {
  const ref = parseReference(input);
  if (!ref) return null;
  const text = WEB[ref.key];
  return text ? { key: ref.key, label: ref.label, translation: "WEB", text } : null;
}
